import { AnimatePresence, LayoutGroup, motion } from 'framer-motion';
import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Loading } from '../../../../CommonComponents/OPL/Loading/Loading';
import { GoalTypeDTO } from '../../../types/goalsDTO';
import { useGoal } from '../../hooks/useGoal';
import { useHeaderButtons } from './useHeaderButtons';
import { useLegacyWhatIfs } from './useLegacyWhatIfs';

export const HeaderButtons = () => {
  const { isLoading, isFetching, data: goal } = useGoal();

  useLegacyWhatIfs();

  const {
    data: { showWhatIfs, showAddGoal, isWhatIfsOpen, isPlanImpactLoading },
    actions: { openWhatIfs, handleAddGoal },
  } = useHeaderButtons();

  if (isLoading) {
    return null;
  }

  if (!goal) {
    return null;
  }

  return (
    <Box display="flex">
      {goal.GoalType !== GoalTypeDTO.Decumulation &&
        isWhatIfsOpen &&
        (isFetching || isPlanImpactLoading) && <Loading text="Loading" size="small" />}

      <LayoutGroup>
        {showAddGoal && (
          <motion.span
            layout
            animate={{ opacity: 1 }}
            transition={{
              opacity: { ease: 'linear' },
              layout: { duration: 0.3 },
            }}
          >
            <Button
              variant={showWhatIfs ? 'secondary' : 'primary'}
              leftIcon="far fa-flag"
              onClick={handleAddGoal}
              ml="16"
            >
              Add Goal
            </Button>
          </motion.span>
        )}

        <AnimatePresence>
          {showWhatIfs && (
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ delay: 0.3 }}
            >
              <Button leftIcon="far fa-sliders-h" onClick={openWhatIfs} ml="16">
                What-Ifs
              </Button>
            </motion.span>
          )}
        </AnimatePresence>
      </LayoutGroup>
    </Box>
  );
};
